<div class="container">
  <div class="row">
    <p class="bold">{{ headline() | translate }}</p>
    <customer-component-tooltip style="margin-left: 4px">
      <span [innerHTML]="tooltipText() | translate"></span>
    </customer-component-tooltip>
  </div>
  <div class="row">
    <p class="bold female-color">{{ 'merit-budget.hr-research.gender-pay-scale.female' | translate }}</p>
    <p class="bold male-color">{{ 'merit-budget.hr-research.gender-pay-scale.male' | translate }}</p>
  </div>
  <div class="scale-container">
    <div class="scale">
      <div class="icon-wrapper">
        <mat-icon class="female">female</mat-icon>
      </div>
      <div
        #indicatorWrapper
        class="indicator-wrapper female">
        <div
          #femaleIndicator
          class="indicator"></div>
        @if (hasFemaleGap) {
          <div class="separator">
            <div class="square"></div>
          </div>
        }
      </div>
    </div>

    <div class="center">
      @if (hasNoGap) {
        <div class="separator">
          <div class="square"></div>
        </div>
      }
      @if (!hasNoGap) {
        <div class="dot"></div>
      }
    </div>

    <div class="scale">
      <div class="indicator-wrapper male">
        <div
          #maleIndicator
          class="indicator"></div>
        @if (hasMaleGap) {
          <div class="separator">
            <div class="square"></div>
          </div>
        }
      </div>
      <div class="icon-wrapper">
        <mat-icon class="male">male</mat-icon>
      </div>
    </div>
  </div>
  <div class="row text-row">
    <div
      #percentageTextWrapper
      class="info-text-wrapper">
      <p
        #percentageText
        class="bold"
        [ngClass]="{ 'female-color': hasFemaleGap, 'male-color': hasMaleGap }">
        {{ percentage | coinNumberView: false : true }}%
        {{ (hasFemaleGap ? moreFemaleText() : moreMaleText()) | translate }}
      </p>
    </div>
  </div>
</div>
@if (showInformation()) {
  <div class="information-text">
    <p class="bold">{{ 'merit-budget.hr-research.gender-pay-gap.headline' | translate }}</p>
    <p [innerHTML]="'merit-budget.hr-research.gender-pay-gap.text' | translate"></p>
  </div>
}
